import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onOpenChatButtonClick: ({
	experimentCohort,
	...props
}: commonAttributesType & {
	experimentCohort?: string;
}) => AnalyticsEventPayload = ({
	experimentCohort,
	...props
}: commonAttributesType & {
	experimentCohort?: string;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerOpenChatButton',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			experimentCohort,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
